// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2i2TD","title":"Info_title__QmYSn","selects":"Info_selects__3hShv","requiredAsterisk":"Info_requiredAsterisk__37h93"};